import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Constants} from '../../utils/constants';
import {BillingDataRepository} from '../../repositories/billing-data.repository';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {NotificationService} from '../../services/common/notification.service';
import {Utilities} from '../../utils/utilities';
import {CoreDataService} from '../../services/wrapper/core-data.service';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit, OnChanges {
    @Output() callback: any = new EventEmitter();
    @Input() addressData: any;
    @Input() title: string;
    @Input() withoutAddress = false;
    @Input() inlineForm = false;
    @Input() onlyShow = false;
    @Input() oneLine = false;

    public isEdit = false;
    public addressForm: FormGroup;
    public countries: any[];
    public cities: any[];
    public addressTypes: any[];

    constructor(public formBuilder: FormBuilder,
                private billingDataService: BillingDataRepository,
                private notificationService: NotificationService,
                private coreDataService: CoreDataService) {
        this.countries = Utilities.createMultiSelectElements(coreDataService.getLocalizations(), 'code', 'code');
        this.cities = Constants.ADDRESS_CONST.CITIES;
        this.addressTypes = Constants.ADDRESS_CONST.ADDRESS_TYPES;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initForm();
    }

    ngOnInit() {
        this.initForm()
        console.log(this.addressData);
    }

    saveAddress() {
        const payload = this.getBillingDataPayload();
        this.billingDataService.updateWithoutId(payload).subscribe(response => {
            this.notificationService.showSuccessWithoutTranslation('Modification is success');
            this.addressData = payload.attribute;
            this.isEdit = false;
            this.callback.emit(response);
        });
    }

    public getBillingData() {
        return this.getBillingDataPayload().attribute;
    }

    private getBillingDataPayload() {
        const payload: PostPayloadInterface = {
            id: 0,
            type: 'UpdateBillingData',
            attribute: {}
        };
        // payload.attribute.id = this.addressForm.get('id').value;
        payload.attribute.firstName = this.addressForm.get('firstName').value;
        payload.attribute.lastName = this.addressForm.get('lastName').value;
        payload.attribute.phoneNumber = this.addressForm.get('phoneNumber').value;
        payload.attribute.email = this.addressForm.get('email').value;
        payload.attribute.taxNumber = this.addressForm.get('taxNumber').value;
        payload.attribute.companyName = this.addressForm.get('companyName').value;
        if (!this.withoutAddress) {
            payload.attribute.address = {
                // id: this.addressForm.get('addressId').value,
                city: this.addressForm.get('addressCity').value,
                addressType: 'STREET',
                houseNumber: this.addressForm.get('houseNumber').value,
                address: this.addressForm.get('addressAddress').value,
                zipCode: this.addressForm.get('addressZipCode').value,
                country: this.addressForm.get('addressCountry').value
            };
        }
        return payload;
    }

    private initForm() {
        if (this.inlineForm) {
            this.isEdit = true;
        }
        if (this.addressData != null) {
            if (this.addressData.address == null) {
                this.withoutAddress = true;
            }
            if (this.withoutAddress) {
                this.addressForm = this.formBuilder.group(
                    {
                        firstName: [this.addressData.firstName, [Validators.required, Validators.minLength(2)]],
                        lastName: [this.addressData.lastName, [Validators.required, Validators.minLength(2)]],
                        email: [this.addressData.email, [Validators.required, Validators.email]],
                        phoneNumber: [this.addressData.phoneNumber, [Validators.required]],
                        taxNumber: [this.addressData.taxNumber?this.addressData.taxNumber:''],
                        companyName: [this.addressData.companyName?this.addressData.companyName:'']
                    });
            } else {
                this.addressForm = this.formBuilder.group(
                    {
                        firstName: [this.addressData.firstName, [Validators.required, Validators.minLength(2)]],
                        lastName: [this.addressData.lastName, [Validators.required, Validators.minLength(2)]],
                        email: [this.addressData.email, [Validators.required, Validators.email]],
                        phoneNumber: [this.addressData.phoneNumber, [Validators.required]],
                        taxNumber: [this.addressData.taxNumber?this.addressData.taxNumber:''],
                        companyName: [this.addressData.companyName?this.addressData.companyName:''],
                        addressCity: [this.addressData.address.city, [Validators.required]],
                        addressZipCode: [this.addressData.address.zipCode, [Validators.required, Validators.minLength(4)]],
                        addressCountry: [this.addressData.address.country, [Validators.required]],
                        addressAddress: [this.addressData.address.address, [Validators.required, Validators.minLength(2)]],
                        houseNumber: [this.addressData.address.houseNumber, [Validators.required, Validators.minLength(1)]],
                    });
            }

        }
    }
}
